import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ComingSoonBanner from "./ComingSoonBanner";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#09090b] text-[#fafafa]" data-testid="site-layout">
      <ComingSoonBanner />
      <Header />
      <main className="flex-1 pt-[112px]" data-testid="site-main">{children}</main>
      <Footer />
    </div>
  );
}
